function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const DEFAULT_ID_PREFIX = 'dropdown';

/**
 * Dropdown with a few defaults to save a couple of copy pasted lines here and there.
 * Options: array of objects [{ key, value, text }] or array of strings (mapped to { key, value, text }).
 * Optional label/layout: pass label (and optionally labelColSpan, fieldName) to render as a row with label like TextFormFieldRow.
 *
 * @param {Array} options - Array of the form [{ key: string, value: string, text: string }] OR Array of strings
 */
export default function Dropdown(_ref) {
  let {
    name,
    value,
    onChange,
    options = [],
    showNullOption = true,
    passEntireEvent = false,
    id: idProp,
    dataTestId,
    label,
    labelColSpan = 3,
    fieldName,
    marginClass = 'mb-2',
    dropdownStyle = {
      minWidth: '200px'
    },
    labelStyle = {},
    componentStyle = {},
    ...props
  } = _ref;
  const {
    t
  } = useTranslation();
  const field = fieldName ?? name;
  const id = idProp ?? `${DEFAULT_ID_PREFIX}_${field}`.replace(/\./g, '_');
  if (dataTestId == null || dataTestId === '') {
    console.error('Dropdown: dataTestId is required for accessible testing. ' + `Provide dataTestId for field "${field}". Do not derive test id from label or id.`);
  }
  let dropDownOptions = options;
  if (options.length > 0 && typeof options[0] === 'string') {
    dropDownOptions = options.map(o => ({
      key: o,
      value: o,
      text: o
    }));
  }
  const selectControl = /*#__PURE__*/React.createElement(Form.Control, _extends({
    as: "select",
    id: id,
    name: name ?? field,
    value: value,
    onChange: e => onChange(passEntireEvent ? e : e.target.value),
    size: "md",
    type: "text",
    style: dropdownStyle,
    "data-testid": dataTestId || undefined
  }, props), showNullOption && /*#__PURE__*/React.createElement("option", {
    value: null
  }), dropDownOptions.map(o => /*#__PURE__*/React.createElement("option", {
    value: o.value,
    key: o.key ?? o.value
  }, t(o.text))));
  if (label != null) {
    return /*#__PURE__*/React.createElement(Form.Group, {
      className: `${marginClass} Dropdown Dropdown-${field}`,
      as: Row,
      style: componentStyle
    }, /*#__PURE__*/React.createElement(Form.Label, {
      className: "Dropdown-FormLabel",
      column: "md",
      md: labelColSpan,
      htmlFor: id,
      style: labelStyle
    }, t(`${label}`)), /*#__PURE__*/React.createElement(Col, null, selectControl));
  }
  return selectControl;
}